__webpack_require__.p = "https://calm-wave-003DC1203.5.azurestaticapps.net/";